module.exports = __webpack_public_path__ + "static/media/google-email-connect.a2305d0b.gif";